module.exports = __webpack_public_path__ + "img/12.3fb63756.jpg";